"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listProduct = listProduct;
exports.createProduct = createProduct;
exports.updateProduct = updateProduct;
exports.deleteProduct = deleteProduct;
exports.productAll = productAll;

var _request = _interopRequireDefault(require("@/utils/request"));

function listProduct(query) {
  return (0, _request.default)({
    url: '/product/list',
    method: 'get',
    params: query
  });
}

function createProduct(data) {
  return (0, _request.default)({
    url: '/product/create',
    method: 'post',
    data: data
  });
}

function updateProduct(data) {
  return (0, _request.default)({
    url: '/product/update',
    method: 'post',
    data: data
  });
}

function deleteProduct(data) {
  return (0, _request.default)({
    url: '/product/delete',
    method: 'post',
    data: data
  });
}

function productAll() {
  return (0, _request.default)({
    url: '/product/productAll',
    method: 'get'
  });
}